<template>
  <div>
    <div id="StepIndicator" class="stepIndicator" v-if="showServe">
      <el-select v-model="value" :popper-append-to-body="false" :no-data-text="'Không có dữ liệu'"
        class="stepIndicator__select">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"
          :disabled="item.disabled" @click.native="scrollTo(item)">
        </el-option>
      </el-select>
    </div>
    <div style="margin-top: 0px">
      <div class="container">
        <div class="banner">
          <div class="banner-content banner-img">
            <div class="banner-content__center">
              <img :src="$isMobile
                ? gameData.background_small_img
                : gameData.background_img
                " alt="" />
            </div>
          </div>
          <img :src="gameData.game_icon" alt="logo" class="banner-logo" style="display: none" /><span
            class="banner-title" style="display: none">{{
              gameData.game_name
            }}</span>
        </div>
        <div class="content content_1" ref="info" id="info">
          <div class="content-box">
            <div class="content-box__header">
              <div>
                <span class="content-box__header-number">1</span>
                <span class="content-box__header-content">
                  Tài khoản Game ID
                </span>
              </div>
            </div>
            <div class="content-box__content">
              <div class="loginForm" v-if="!showServe">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                  <el-form-item label="">
                    <el-select style="width: 100%" :popper-append-to-body="false" :no-data-text="'Không có dữ liệu'"
                      :no-match-text="'Không có dữ liệu'" v-model="form.servers" @change="handleChange" filterable
                      placeholder="Chọn máy chủ">
                      <el-option :label="item.value" :value="item.id" v-for="item in servers_roles.servers"
                        :key="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="">
                    <el-select style="width: 100%" :popper-append-to-body="false" v-model="form.roles"
                      :no-data-text="'Không có dữ liệu'" :no-match-text="'Không có dữ liệu'" :disabled="!form.servers"
                      filterable placeholder="Chọn nhân vật">
                      <el-option :label="item.value" :value="item.id" v-for="item in servers_roles.roles"
                        :key="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" style="
                        width: 100%;
                        background: rgb(17, 136, 255);
                        border-color: transparent;
                      " :style="{
                        background:
                          form.servers && form.roles
                            ? 'rgb(17,136,255)'
                            : '#ebebeb',
                      }" :disabled="!form.servers || !form.roles" @click="submitRole()">Xác nhận</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div v-else>
                <div class="el-row" style="margin-left: -5px; margin-right: -5px">
                  <div class="el-col el-col-24" style="padding-left: 5px; padding-right: 5px">
                    <div class="custom-userInfo">
                      <p>
                        <span style="min-width: 67.0312px"> Máy chủ: </span>
                        <code style="display: inline-block">
                          {{ showRolesInfo.serversName }}
                        </code>
                      </p>
                      <p>
                        <span style="min-width: 85.2415px"> ID nhân vật: </span>
                        <code style="display: inline-block">
                          {{ showRolesInfo.id }}
                        </code>
                      </p>
                      <p>
                        <span style="min-width: 72.7557px"> Nhân vật: </span>
                        <code style="display: inline-block">
                          {{ showRolesInfo.roleName }}
                        </code>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="errorWrapper">
                  <button type="button" class="el-button btnLogout el-button--text" @click="removeServe()">
                    Chọn nhân vật khác
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 选择商品 -->
        <div class="content" v-if="showServe" ref="goods" id="goods">
          <div class="content-box">
            <div class="content-box__header">
              <div>
                <span class="content-box__header-number">2</span>
                <span class="content-box__header-content"> Chọn gói </span>
              </div>
              <div>
                <div class="filter-btn" v-for="(item, index) in filterBtn" :key="index"
                  :class="{ selected: selectedButton === index }" @click="filterCheck(item, index)">
                  <span>{{ item }}</span>
                </div>
              </div>
            </div>
            <!-- <el-radio-group
                v-model="chooseProduct"
                @change="chooseProductType"
              >
                <el-radio-button label="1">Xu Game</el-radio-button>
                <el-radio-button label="2">Đặc biệt</el-radio-button>
              </el-radio-group> -->
            <div class="content-box__content">
              <div id="product_list">
                <div class="list-item-bg" v-for="item in productInfo" :key="item.id" @click="choosePay(item)">
                  <div class="list-item">
                    <div class="list-item-img">
                      <img :src="item.product_img" />
                      <!-- <div class="show-shopping">
                        <div><i class="el-icon-shopping-cart-full"></i></div>
                      </div> -->
                      <div class="list-item-pay">
                        <span class="list-item-pay__price">
                          <span style="font-weight: bold; margin-right: 3px;"> {{ item.price_code }} </span>
                          <span>{{ item.need_pay / 1000 + 'k' }}</span>
                          <span class="list-item-pay__button">
                            <div><i class="el-icon-shopping-cart-full"></i></div>
                          </span>
                        </span>

                      </div>
                      <img src="@/assets/free.png" class="free_chance" v-if="item.free_chance > 0" />
                    </div>
                    <div class="list-item-box" v-if="false">
                      <div class="list-item-rebate">
                        hoàn trả ：{{ item.rebate }} coin
                        <div class="list-item-rebate-radius"></div>
                      </div>
                      <img class="list-item-box-shop" src="../../assets/img/shop.png?1" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 选择支付方式 -->
        <div class="content" v-if="showPay" ref="pay" id="pay">
          <div class="content-box">
            <div class="content-box__header">
              <div>
                <span class="content-box__header-number">3</span>
                <span class="content-box__header-content">
                  Chọn phương thức thanh toán
                </span>
              </div>
            </div>
            <el-checkbox-group :value="checkList">
              <div class="content-box__content">
                <el-collapse v-model="activeNames" @change="handleCheck" accordion>
                  <el-collapse-item :title="item.title" :name="item.title"
                    v-for="(item, index) in productDetail.data.newAtm" :key="index">
                    <!-- :class="{ 'gray-collapse-item': item.atm[0].disabled }" -->
                    <template slot="title">
                      <div class="pmt-group">
                        <!-- <div class="pmt-group__img zalopay-icon-small">
                        </div> -->
                        <!-- <div
                          class="pmt-group__img"
                          :class="'pmt-group__img' + index"
                        >
                        </div> -->
                        <div class="pmt-group__name">
                          <div class="displayName">
                            <p>
                              {{ item.title }}
                              <span v-if="item.title === 'Coin'">
                                (Số dư :
                                {{
                                  Number($store.state.gameData.coin) +
                                  Number($store.state.gameData.bind_coin)
                                }})
                              </span>
                              <span v-if="
                                [
                                  4,
                                  5,
                                  'TECH',
                                  'TECH_MOMO',
                                  'TECH_ZALO',
                                ].includes(item.atm[0].pay_type)
                              " style="color: red">
                                <!-- hot! -->
                                <img style="width: 20px" src="@/assets/fire.png" alt="" />
                              </span>
                            </p>
                            <p class="minAmount">{{ item.need_pay }} VND</p>
                          </div>
                        </div>
                      </div>
                      <div @click.stop>
                        <el-checkbox class="check_box" :disabled="item.atm[0].disabled" :label="item.title"
                          @change="handleCheck(item.title)">&nbsp;</el-checkbox>
                      </div>
                    </template>
                    <div class="el-row" style="margin-left: -5px; margin-right: -5px">
                      <div class="el-col el-col-8" :class="{ 'el-col-24': $isMobile }"
                        style="padding-left: 5px; padding-right: 5px" @click="chooseCoupon(i, ind, item)"
                        v-for="(i, ind) in item.atm" :key="ind">
                        <div class="pmt-method" :class="{
                          selected:
                            couponActive === ind && i.name === couponName,
                        }">
                          <span class="pmt-method__info">
                            <span class="pmt__cost">
                              <span v-if="i.name === 'Coin'">
                                {{
                                  Number($store.state.gameData.coin) +
                                  Number($store.state.gameData.bind_coin)
                                }}
                              </span>
                              <span v-else>
                                Tặng thêm {{ i.give_coin || "0" }}
                              </span>
                            </span>
                          </span>
                          <div class="pmt-method__name">
                            <span>{{ i.name }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
                <el-button type="primary" style="
                    width: 100%;
                    background: rgba(17, 136, 255);
                    border-color: transparent;
                    margin-top: 10px;
                  " v-if="this.couponName !== null && this.couponActive !== null" @click="chooseCouponNext()">Tiếp
                  theo</el-button>
              </div>
            </el-checkbox-group>
          </div>
        </div>
        <!-- 商品信息 -->
        <div class="content" v-if="showGoodsInfo" ref="goodsInfo" id="goodsInfo">
          <div class="content-box">
            <div class="content-box__header">
              <div>
                <span class="content-box__header-number">4</span>
                <span class="content-box__header-content">
                  Xác nhận thông tin
                </span>
              </div>
            </div>
            <div class="content-box__content">
              <!-- <h2 class="list-title">{{ goodsInfo.product_info }}</h2> -->
              <div class="list-info">
                <div class="package-item">
                  <img :src="goodsInfo.product_img" alt="" />
                </div>
                <div class="info-detail">
                  <p>
                    <span>Máy chủ:</span>
                    <code class="serverName">
              {{ showRolesInfo.serversName }}
            </code>
                  </p>
                  <p>
                    <span>ID nhân vật:</span>
                    <code class="roleId">
              {{ showRolesInfo.id }}
            </code>
                  </p>
                  <p>
                    <span>Nhân vật:</span>
                    <code class="roleName">{{ showRolesInfo.roleName }}</code>
                  </p>
                  <p>
                    <span>Thanh toán:</span>
                    <code class="pmtMethod">{{ goodsInfo.name }}</code>
                  </p>
                  <p v-if="goodsInfo.name !== 'Coin'">
                    <span>Chọn Coupon: </span>
                    <code class="pmtMethod choose_coupon" @click="openCouponDialog">
              <span class="coupon_title" v-if="goodsInfo.coupon_title">
                {{ goodsInfo.coupon_title }}
              </span>
              <span v-else-if="useCouponNum > 0">
                {{ useCouponNum }} voucher có thể sử dụng
              </span>
              <span v-else style="color: grey">Chưa có có thể dùng
              </span>
              <i class="el-icon-arrow-right"></i>
            </code>
                  </p>
                  <p>
                    <span>giá bán</span>
                    <code class="pmtMethod">
              <span v-if="goodsInfo.name === 'Coin'">{{
                Number(goodsInfo.order_amt_platform)
              }}</span>
              <span v-else-if="goodsInfo.coupon_type === '3'" class="description_reduce">
                <span>{{ Number(goodsInfo.order_amt) }} </span>
                {{ Number(goodsInfo.coupon_discount_amount) }}
                <div class="more">
                  (Tặng thêm
                  <a @click="openMoreDialog(goodsInfo)">
                    {{ Number(goodsInfo.total_give) }}</a>
                  <!-- <div class="_coupon_item_explain"></div> -->
                  )
                </div>
              </span>
              <span v-else class="description_reduce">
                {{
                  Number(goodsInfo.order_amt) +
                  Math.ceil((goodsInfo.order_amt * goodsInfo.fee) / 100)
                }}
                <div class="more">
                  (Tặng thêm
                  <a @click="openMoreDialog(goodsInfo)">
                    {{ Number(goodsInfo.total_give) }}</a>)
                  <!-- <div class="_coupon_item_explain"></div> -->
                </div>
              </span>
            </code>
                  </p>
                </div>
              </div>
              <!-- <p class="confirmPolicy" v-if="goodsInfo.product_info">
                Chi tiết sản phẩm ：{{ goodsInfo.product_info }}
              </p> -->
              <p class="confirmPolicy">
                Bằng việc nhấn vào nút Thanh toán ngay, Bạn đồng ý rằng, giao
                dịch này là không hoàn, không hủy.
              </p>
              <!-- <p class="confirmPolicy" style="color: red;">
                Giao dịch đang xử lý, nếu gặp bất cứ vấn đề gì xin hãy phản hồi cho chúng tôi qua phần "Lỗi nạp"
              </p> -->
              <div class="free_chance_color" v-if="goodsInfo.rebate === 1 && free_chance > 0">
                Bạn còn <span>{{ free_chance }}</span> lần tham gia miễn phí đơn
                hạn giờ (Coin cao nhất có thể phải nạp), dùng voucher không thể
                tham gia hoạt động
              </div>
              <el-button type="primary" style="
                  width: 100%;
                  background: rgba(17, 136, 255);
                  border-color: transparent;
                " @click="handlePay()">Xác nhận</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading1 :show="showLoading" :backgroundColor="false" />
    <GiftCode ref="giftCode" />
    <More ref="more" />
    <Coupon ref="showCoupon" />
  </div>
</template>

<script>
import { debounce } from "lodash";
import Loading1 from "../../components/Loading1";
import GiftCode from "../../components/giftCode.vue";
import More from "../../components/more";
import Coupon from "../../components/coupon.vue";
// import showMessage from "../../utils/showMessage";
export default {
  name: "",
  mixins: [],
  components: {
    Loading1,
    GiftCode,
    More,
    Coupon,
  },
  props: {},
  data() {
    return {
      checkList: [],
      payData: {
        cp_sid: "", // 区服id
        cp_roleid: "", // 角色id
        product_id: "", // 商品id
        pay_type: "", // 支付类型
        channel: "", // 支付渠道
        user_coupon_id: "", //优惠券id
      },
      filterBtn: ["Xu Game", "Đặc biệt"], //切换商品按钮
      selectedButton: 0, //判断选中的按钮索引
      selectServe: false, //选择区服
      servers_roles: {
        servers: [],
        roles: [],
      }, //区服角色
      showRolesInfo: {}, //页面展示角色
      showServe: false, //展示区服
      showLoading: false, //loading状态
      showPay: false, //展示支付方式
      showCoupon: false, //展示优惠券
      channelShow: false, //优惠券使用详情下拉
      checkNum: null, //优惠券被选中
      couponActive: null, //支付方式被选中
      showGoodsInfo: false, //展示商品信息
      chooseProduct: "1", //选择商品
      activeNames: [], //默认下拉
      couponName: "", //选中的支付方式名字
      ruleForm: {
        name: "",
        password: "",
        type: "1",
      },
      form: {
        servers: "",
        roles: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "Vui lòng nhập tài khoản message",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "Vui lòng nhập mật khẩu",
            trigger: "blur",
          },
        ],
      },
      options: [
        {
          value: "1",
          label: "Bước 1/4: Tài khoản Game ID",
          name: "info",
          disabled: false,
        },
        {
          value: "2",
          label: "Bước 2/4:Chọn gói",
          name: "goods",
          disabled: false,
        },
        {
          value: "3",
          label: "Bước 3/4:Chọn phương thức thanh toán",
          name: "pay",
          disabled: true,
        },
        {
          value: "4",
          label: "Bước 4/4:Xác nhận thông tin",
          name: "goodsInfo",
          disabled: true,
        },
      ],
      value: "1", //下拉选项
      productInfoData: [], //商品
      productInfo: [], //商品
      productInfo1: [], //商品1
      productInfo2: [], //商品2
      productDetail: {},
      free_chance: 0, //免单次数
      useCouponNum: 0, //可用x张优惠券
      goodsInfo: {
        name: "", //支付方式名称
        order_amt: "", //价格
        coupon_discount_amount: "", //优惠券满减
        coupon_reduce_amt: "", //扣完优惠券后的价格
        order_amt_platform: "", //coin价格
        total_give: "", //所有优惠加起来的数目
        give_coin: "", //支付方式给的优惠
        level: "", //Vip等级
        extra_coin: "", //税率
        extra_coin_num: "", //vip送的优惠
        coupon_give_coin: "", //优惠券送的优惠
        coupon_title: "", //优惠券名称
        coupon_type: "", //优惠券类型
        product_img: "", //产品图片
        product_info: "", //产品名称
        rebate: 0, //渠道返利
        checkNum: null, //优惠券索引
        coupon_info: {}, //优惠券信息
      },
      spareGoodsInfo: {},
      gateData: {}, //gate相关数据
      gameData: {}, //游戏点击进来的数据
      standbyName: null, //备用支付方式索引值
    };
  },
  computed: {},
  created() { },
  mounted() {
    this.loading();
    this.handleScroll();
    let token = JSON.parse(localStorage.getItem("token"));
    let serve = JSON.parse(localStorage.getItem("service"));
    // if (account) {
    //   this.selectServe = true;
    // }
    if (token) {
      this.getServerInfoData();
      this.getGateData();
    }
    if (serve) {
      this.showServe = true;
      this.$store.state.showServe = true;
      this.showRolesInfo = serve;
      this.getProductInfoData(serve);
    }
  },
  methods: {
    //进入页面时loading
    loading() {
      this.showLoading = false;
      setTimeout(() => {
        this.showLoading = false;
      }, 2000);
    },
    // 点击跳转
    scrollTo(item) {
      if (item.disabled) {
        return;
      }
      this.$nextTick(() => {
        let scrollTo = this.$refs[item.name];
        scrollTo.scrollIntoView({ block: "start" });
      });
    },
    // 监听页面滚动事件
    handleScroll() {
      window.addEventListener("scroll", this._.debounce(this.scrolling, 50));
    },
    scrolling() {
      let win = window.pageYOffset + 150;
      // const info = this.$refs.info.offsetTop;
      if (!this.$refs.goods) {
        return;
      }
      const goods = this.$refs.goods.offsetTop;
      let pay, goodsInfo;
      if (this.showPay) {
        pay = this.$refs.pay.offsetTop;
      }
      if (this.showGoodsInfo) {
        goodsInfo = this.$refs.goodsInfo.offsetTop;
      }
      if (win < goods) {
        this.value = "1";
      } else if (win > goods && win < pay) {
        this.value = "2";
      } else if (win > pay && win < goodsInfo) {
        this.value = "3";
      } else if (win > goodsInfo) {
        this.value = "4";
      } else {
        this.value = "2";
      }
    },
    //打开礼包码弹窗
    openGiftCodeDialog() {
      if (this.goodsInfo.name === "Coin") {
        return;
      }
      this.$refs.giftCode.dialogFormVisible = true;
    },
    //打开优惠券弹框
    openCouponDialog() {
      this.$refs.showCoupon.checkNum = this.goodsInfo.checkNum;
      if (this.goodsInfo.checkNum !== null) {
        this.$refs.showCoupon.productDetail.data.coupon[
          this.goodsInfo.checkNum
        ].check = true;
      } else {
        this.$refs.showCoupon.productDetail.data.coupon.forEach((item) => {
          item.check = false;
        });
      }
      this.$refs.showCoupon.dialogFormVisible = true;
    },
    //选择区服时
    handleChange(e) {
      this.form.roles = "";
      let roles = this.servers_roles.servers.filter((item) => {
        return item.id === e;
      });
      this.servers_roles.roles = roles[0].childs;
      this.showRolesInfo.serversId = roles[0].id;
      this.showRolesInfo.serversName = roles[0].value;
    },
    //确认角色
    submitRole() {
      this.showLoading = false;
      let roles = this.servers_roles.roles.filter((item) => {
        return item.id === this.form.roles;
      });
      this.showRolesInfo.id = roles[0].id;
      this.showRolesInfo.r_id = roles[0].r_id;
      this.showRolesInfo.roleName = roles[0].value;
      this.showServe = true;
      localStorage.setItem("service", JSON.stringify(this.showRolesInfo));
      this.getProductInfoData(this.showRolesInfo);
    },
    //移除区服角色
    removeServe() {
      this.showLoading = false;
      localStorage.removeItem("service");
      this.showServe = false;
      this.$store.state.showServe = false;
      this.showPay = false; //展示支付方式
      this.showCoupon = false; //展示优惠券
      this.showGoodsInfo = false; //展示商品信息
      this.ruleForm = {
        name: "",
        password: "",
        type: "1",
      };
      this.form = {
        servers: "",
        roles: "",
      };
      setTimeout(() => {
        this.showLoading = false;
      }, 2000);
    },
    //打开支付额外金额获取流水弹窗
    openMoreDialog(goodsInfo) {
      this.$refs.more.dialogFormVisible = true;
      this.$refs.more.goodsInfo = goodsInfo;
    },
    //移除所有登入状态
    removeStatus() {
      this.showLoading = false;
      localStorage.removeItem("account");
      localStorage.removeItem("token");
      localStorage.removeItem("service");
      this.selectServe = false;
      this.showServe = false;
      this.showPay = false; //展示支付方式
      this.showCoupon = false; //展示优惠券
      this.showGoodsInfo = false; //展示商品信息
      this.ruleForm = {
        name: "",
        password: "",
        type: "1",
      };
      this.form = {
        servers: "",
        roles: "",
      };
      setTimeout(() => {
        this.showLoading = false;
      }, 2000);
    },
    //跳转页面
    toPage() {
      this.$router.push("/");
    },
    //选择商品
    choosePay(item) {
      //重构支付方式数据
      this.showLoading = false;
      this.free_chance = item.free_chance;
      // localStorage.setItem("product", JSON.stringify(item));
      this.getProductDetail(item);
    },
    // 选择优惠券
    chooseCoupon(item, index, i) {
      if (i.title === "Cổng khác") {
        this.checkList = [];
      }

      //如果gate值不够提示余额不足
      let coin =
        Number(this.$store.state.gameData.coin) +
        Number(this.$store.state.gameData.bind_coin);
      const arr = ["Coin", "MoMo", "BankQR", "ATMCARD", "VISA"];
      if (item.name === "Coin" && coin < i.need_pay) {
        // showMessage("Số dư không đủ", "warning");
        if (!arr.includes(this.couponName) && this.couponName) {
          this.activeNames = ["Cổng khác"];
        } else {
          this.checkList[0] = this.couponName;
        }
        this.$message.warning("Số dư không đủ");
        return;
      }
      if (item.disabled) {
        if (!arr.includes(this.couponName) && this.couponName) {
          this.activeNames = ["Cổng khác"];
        } else {
          this.checkList[0] = this.couponName;
        }

        if (item.maintain) {
          this.$message.warning(
            `Đang bảo trì, xin chọn phương thức thanh toán khác`
          );
        } else {
          this.$message.warning(`Mức nạp thấp nhất ${item.min}`);
        }
        // showMessage(`Mức nạp thấp nhất ${item.min}`, "warning");
        return;
      }
      this.showGoodsInfo = false;
      this.options[3].disabled = true;

      const { channel, pay_type } = item;
      this.payData.channel = channel;
      this.payData.pay_type = pay_type;
      // 每次选择支付方式前清空一遍数据
      this.goodsInfo = {
        name: "", //支付方式名称
        order_amt: "", //价格
        coupon_discount_amount: "", //优惠券满减
        coupon_reduce_amt: "", //扣完优惠券后的价格
        order_amt_platform: "", //coin价格
        total_give: "", //所有优惠加起来的数目
        give_coin: "", //支付方式给的优惠
        level: "", //Vip等级
        extra_coin: "", //税率
        extra_coin_num: "", //vip送的优惠
        coupon_give_coin: "", //优惠券送的优惠
        coupon_title: "", //优惠券名称
        coupon_type: "", //优惠券类型
        product_img: "", //产品图片
        product_info: "", //产品名称
        rebate: "", //渠道返利
        need_pay: "", //需要支付的方式
        checkNum: null, //优惠券索引
        coupon_info: {}, //优惠券信息
      };
      //填充数据
      const {
        order_amt,
        order_amt_platform,
        level,
        extra_coin,
        product_img,
        product_info,
        newAtm,
      } = this.productDetail.data;
      this.goodsInfo.name = item.name;
      this.goodsInfo.give_coin = item.give_coin || "";
      this.goodsInfo.order_amt = order_amt;
      this.goodsInfo.order_amt_platform = order_amt_platform;
      this.goodsInfo.level = level;
      this.goodsInfo.extra_coin = extra_coin;
      this.goodsInfo.extra_coin_num = (extra_coin / 100) * order_amt;
      this.goodsInfo.product_img = product_img;
      this.goodsInfo.product_info = product_info;
      this.goodsInfo.total_give =
        Number(this.goodsInfo.give_coin) +
        Number(this.goodsInfo.extra_coin_num);
      this.goodsInfo.rebate = item.rebate;
      this.goodsInfo.need_pay = i.need_pay;
      this.goodsInfo.fee = newAtm[index].fee; //费率

      this.spareGoodsInfo = JSON.parse(JSON.stringify(this.goodsInfo));

      //逻辑方面
      //选中支付方式
      if (this.couponName == item.name && this.couponActive == index) {
        this.couponName = null;
        this.couponActive = null;
        this.showCoupon = false;
        this.showGoodsInfo = false;
        this.options[3].disabled = true;
      } else {
        this.couponName = item.name;
        this.standbyName = item.name;
        this.$refs.showCoupon.couponName = item.name;
        this.couponActive = index;
      }
      this.useCouponNum = 0;
      this.productDetail.data.coupon.forEach((item) => {
        if (
          !(
            (!item.channel_type_arr.includes(this.couponName) &&
              item.title !== "Coin") ||
            item.limit_time > 0 ||
            (item.usage_num_daily > 0 && item.usage_num_daily_count <= 0)
          )
        ) {
          this.useCouponNum++;
        }
      });
    },

    chooseCouponNext() {
      //如果gate值不够提示余额不足
      // let coin =
      //   Number(this.$store.state.gameData.coin) +
      //   Number(this.$store.state.gameData.bind_coin);
      // if (this.goodsInfo.name === "Coin" && coin < this.goodsInfo.need_pay) {
      //   this.$message.warning("Số dư không đủ");
      //   return;
      // }
      // if (this.goodsInfo.disabled) {
      //   this.$message.warning(` Mức nạp thấp nhất ${this.goodsInfo.min}`);
      //   return;
      // }
      // if (this.couponName == null && this.couponActive == null) {
      //   this.$message.warning(`hãy chọn lại phương thức thanh toán khác`);
      //   return;
      // }
      //显示方面
      if (this.checkNum !== null) {
        this.productDetail.data.coupon[this.checkNum].check = false;
        this.checkNum = null;
      }
      this.showCoupon = true;
      this.showGoodsInfo = true;
      this.options[3].disabled = false;
      this.$nextTick(() => {
        let goodsInfo = this.$refs.goodsInfo;
        goodsInfo.scrollIntoView({ block: "start" });
      });
    },
    //获取区服角色接口
    getServerInfoData() {
      let params = {};
      this.$http.get("/consume/serverInfo", { params }).then((res) => {
        if (res.data.code === 200) {
          this.servers_roles.servers = res.data.data.servers_roles;
          this.$store.state.ServeInfo = res.data.data.servers_roles;
          let service = JSON.parse(localStorage.getItem("service"));
          let trueService = false;
          if (service) {
            this.servers_roles.servers.forEach((item) => {
              item.childs &&
                item.childs.forEach((i) => {
                  if (
                    i.r_id === service.r_id &&
                    item.id === service.serversId
                  ) {
                    trueService = true;
                  }
                });
            });
            if (!trueService) {
              //如果匹配不到任何区服和r_id就取消
              this.removeServe();
            }
          } else {
            this.removeServe();
          }
          this.$store.state.selectServe = true;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //获取商品信息
    getProductInfoData(serve) {
      this.payData.cp_roleid = serve.r_id + "," + serve.id;
      let params = {
        cp_roleid: this.payData.cp_roleid,
      };
      this.$http.get("/consume/productDetail", { params }).then((res) => {
        if (res.data.code === 200) {
          this.productInfoData = res.data.data;
          //默认显示type = 1的数据
          this.productInfoData.forEach((item) => {
            if (String(item.type) === "1") {
              this.productInfo1 = item.product;
            } else {
              this.productInfo2 = item.product;
            }
          });
          this.productInfo = this.productInfo1;
          // this.productInfo = this.productInfoData[this.selectedButton].product;
          this.$store.state.showServe = true;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    filterCheck(item, index) {
      //切换type = 2
      this.selectedButton = index;
      this.productInfo =
        this.selectedButton === 0 ? this.productInfo1 : this.productInfo2;
      // this.productInfo = this.productInfoData[this.selectedButton]
      //   ? this.productInfoData[this.selectedButton].product
      //   : [];
      this.showPay = false;
      this.options[2].disabled = true;
      this.activeNames = []; //关闭
      this.couponActive = null;
      this.showCoupon = false;
      this.showGoodsInfo = false;
      this.options[3].disabled = true;
    },

    //获取gate信息
    getGateData() {
      let params = {};
      this.$http.get("/center/detail", { params }).then((res) => {
        if (res.data.code === 200) {
          this.$store.state.gameData = res.data.data;
          this.gateData = this.$store.state.gameData;
          this.gameData = this.$store.state.gameData;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //获取商品详细信息
    getProductDetail(info) {
      this.$store.state.product = info; //将选取的数据存储到vuex里去
      this.payData.product_id = info.product_id;
      let params = {
        product_id: info.product_id,
      };
      this.$http.get("/consume/detail", { params }).then((res) => {
        if (res.data.code === 200) {
          this.showPay = true;
          this.options[2].disabled = false;
          this.activeNames = []; //关闭
          this.couponActive = null;
          this.showCoupon = false;
          this.showGoodsInfo = false;
          this.options[3].disabled = true;
          this.$nextTick(() => {
            let pay = this.$refs.pay;
            pay.scrollIntoView({ block: "start" });
          });
          this.productDetail = res.data;
          this.$refs.showCoupon.productDetail = res.data;
          const data = this.productDetail.data;
          let coin = [
            {
              title: "Coin",
              need_pay: info.need_pay_platform,
              atm: [
                {
                  name: "Coin",
                  coin: data.coin,
                },
              ],
            },
          ];
          let recommend_atm = [];
          let inf = info;
          data.recommend_atm.forEach((item) => {
            let need_pay = inf.need_pay;
            if (item.fee) {
              need_pay = `${inf.need_pay} (${Math.ceil((inf.need_pay * item.fee) / 100) + "Fee"
                })`;
            }
            let info = {
              need_pay: need_pay,
              title: item.name,
              atm: [item],
              fee: item.fee || "",
            };
            recommend_atm.push(info);
          });
          // let atm = {
          //   title: "Cổng khác",
          //   atm: data.atm,
          //   need_pay: inf.need_pay,
          // };
          let newAtm = [];
          newAtm.push(...coin, ...recommend_atm);
          // newAtm.push(...coin, ...recommend_atm, atm);
          newAtm.forEach((item) => {
            if (item.title === "Coin") {
              let coin =
                Number(this.$store.state.gameData.coin) +
                Number(this.$store.state.gameData.bind_coin);
              item.atm.forEach((i) => {
                i.disabled = coin < item.need_pay ? true : false;
              });
              return;
            }
            item.atm.forEach((i) => {
              if (i.min) {
                i.disabled = i.min > Number(data.order_amt) ? true : false;
              }
              if (i.maintain) {
                i.disabled = i.maintain === 1;
              }
            });
          });
          this.productDetail.data.newAtm = newAtm;
          //优惠券操作
          data.coupon.forEach((item, index) => {
            // 该券是否有 有效时间，没有就显示可用时间
            if (item.valid_start_time) {
              // 有效时间 (券领取后)
              item.date_text = `Thời gian hiệu lực <div style="font-size: 12px;color: #83B8E7;">${item.valid_start_time}—${item.valid_end_time}</div>`;
            } else {
              // 可用时间 (未领取)
              if (item.get_start_time && item.get_end_time) {
                item.date_text = `Thời gian có sẵn <div style="font-size: 12px;color: #83B8E7;">${item.get_start_time}—${item.get_end_time}</div>`;
              } else {
                item.date_text = ``;
              }
            }

            // 处理 满赠/满减 信息;
            switch (item.type) {
              case "1": // 满赠 （固额）
                item.give_coin_text = `Đủ ${item.order_coin} Tặng ${item.give_coin}`;
                break;
              case "2": // 满赠 （比例）
                item.give_coin_text = `Đủ ${item.order_coin} Tặng ${item.rebate}%`;
                break;
              case "3": // 满减 （固额）
                item.give_coin_text = `Đủ ${item.order_coin} Giảm ${item.reduce_amt}`;
                break;
            }

            // 处理券的可用支付渠道信息展示
            item.channel_type_arr.forEach((child, index) => {
              if (index == 0) {
                item.pay_type_text = `${child}`;
              } else {
                item.pay_type_text = `${item.pay_type_text}, ${child}`;
              }
            });
            if (item.limit_time > 0) {
              this._couponStartTiming(item.limit_time, index, item);
            }
            // 优惠券的锁定时间（ps: 选择券下单，券会锁定10分钟不能使用）
            // if (item.limit_time > 0) {
            //   item.limit_time_text = `<div class="_coupon_box_timing">Đang Dùng <span class="_coupon_box_timing_val${index}">${this._getTimeS(
            //     item.limit_time
            //   )}</span></div>`;
            // } else {
            //   item.limit_time_text = "";
            // }
            item.check = false;
            item.channelShow = false;
          });
          // this.productDetail = res.data
          // console.log(res.data);
          //默认MOMO支付
          this.checkList = [];
          this.couponName = null;
          this.couponActive = null;
          this.handleCheck("MoMo");
        } else {
          this.$message.error(res.data.msg);
        }
        setTimeout(() => {
          this.showLoading = false;
        }, 2000);
      });
    },
    _couponStartTiming(ts, key, item) {
      let start = setInterval(function () {
        ts = ts > 0 ? ts - 1 : 0;
        item.limit_time = ts;
        // this.getTimeS(ts);
        if (ts <= 0) {
          clearInterval(start);
        }
      }, 1000);
    },
    changeActive(e) {
      let atmData = this.productDetail.data;
      atmData.newAtm.forEach((item, index) => {
        if (item.title === e) {
          this.chooseCoupon(
            atmData.newAtm[index].atm[0],
            index,
            atmData.newAtm[index]
          );
        }
      });
      // switch (e) {
      //   case "Coin":
      //     this.chooseCoupon(atmData.newAtm[0].atm[0], 0, atmData.newAtm[0]);
      //     break;
      //   case "MoMo":
      //     this.chooseCoupon(atmData.newAtm[1].atm[0], 1, atmData.newAtm[1]);
      //     break;
      //   // case "BankQR":
      //   //   this.chooseCoupon(atmData.newAtm[2].atm[0], 2, atmData.newAtm[2]);
      //   //   break;
      //   case "ATMCARD":
      //     this.chooseCoupon(atmData.newAtm[2].atm[0], 2, atmData.newAtm[2]);
      //     break;
      //   case "VISA":
      //     this.chooseCoupon(atmData.newAtm[3].atm[0], 3, atmData.newAtm[3]);
      //     break;
      //   default:
      //     break;
      // }
    },

    handleCheck(e) {
      const item = this.productDetail.data.newAtm.find(
        (row) => row.title === e
      );
      let atmData = this.productDetail.data;
      atmData.newAtm.forEach((i, index) => {
        if (i.title == e) {
          this.handleCheckBox(item);
          this.activeNames = [];
          this.changeActive(item.title);
        }
      });
      // switch (e) {
      //   case "Coin":
      //     this.handleCheckBox(item);
      //     this.activeNames = [];
      //     this.changeActive("Coin");
      //     break;
      //   case "MoMo":
      //     this.handleCheckBox(item);
      //     this.activeNames = [];
      //     this.changeActive("MoMo");
      //     break;
      //   // case "BankQR":
      //   //   this.handleCheckBox(item);
      //   //   this.activeNames = [];
      //   //   this.changeActive("BankQR");
      //   //   break;
      //   case "ATMCARD":
      //     this.handleCheckBox(item);
      //     this.activeNames = [];
      //     this.changeActive("ATMCARD");
      //     break;
      //   case "VISA":
      //     this.handleCheckBox(item);
      //     this.activeNames = [];
      //     this.changeActive("VISA");
      //     break;

      //   default:
      //     break;
      // }
    },

    handleCheckBox(e) {
      let val = e.title;
      let item = e.atm[0];
      //如果gate值不够提示余额不足
      let coin =
        Number(this.$store.state.gameData.coin) +
        Number(this.$store.state.gameData.bind_coin);
      if (item.name === "Coin" && coin < e.need_pay) {
        return;
      }
      if (item.disabled) {
        return;
      }
      if (val === this.checkList[0]) {
        this.checkList = [];
      } else {
        this.checkList = [val];
      }
    },

    handlePay: debounce(function () {
      const data = JSON.parse(localStorage.getItem("service"));
      this.payData.cp_sid = data.serversId;
      this.payData.cp_roleid = data.r_id + "," + data.id;
      let params = this.payData;
      params.token = localStorage.getItem("token");
      let coin =
        Number(this.$store.state.gameData.coin) +
        Number(this.$store.state.gameData.bind_coin);
      if (
        this.goodsInfo.name === "Coin" &&
        this.goodsInfo.order_amt_platform > coin
      ) {
        this.$message.warning("Số dư không đủ");
        return;
      }
      this.$http.post("/consume/pay", params).then((res) => {
        if (res.data.code === 200) {
          if (res.data.data.redirect_url && res.data.data.redirect_type != 2) {
            window.location.href = res.data.data.redirect_url;
          } else if (res.data.data.redirect_type === 2) {
            this.$router.push({
              path: "/payCode",
              query: {
                redirect_url: res.data.data.redirect_url,
                order_no: res.data.data.order_no,
                type: res.data.data.type,
              },
            });
          } else {
            this.$alert(
              `<div class="alert-message">Thanh toán thành công</div>`,
              {
                dangerouslyUseHTMLString: true,
                confirmButtonText: "Hủy",
              }
            );
            // this.$message.success("Thanh toán thành công");
            this.getGateData(); //重新获取一下coin金额
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    }, 1000),
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrolling);
  },
};
</script>

<style scoped lang="scss">
$color-theme: rgb(17, 136, 255);
$color-theme-rgb: 17, 136, 255;
@import "./css/pc.scss";
@import "./css/phone.scss";

/deep/ .el-form-item__content {
  margin-left: 0 !important;
}

/deep/ .el-popper {
  left: 0px !important;
}

/deep/ .popper__arrow {
  opacity: 0 !important;
}
</style>
<style>
.el-message-box {
  width: auto !important;
}

.alert-message {
  font-size: 18px;
}

@media screen and (max-width: 1000px) {
  .el-message-box {
    width: 75% !important;
  }
}

@media screen and (max-width: 368px) {
  .el-message {
    min-width: 255px;
  }
}
</style>
